export default __webpack_public_path__ + "assets/Nebula-01.b262249c.png";